"use client";
import { useState, useSyncExternalStore } from "react";
import Dialog from "./Dialog";
import { STORE_KEYS } from "app/constants";
import { useStaticStore, useToast, useUserInfo } from "app/hooks";
import { updateEmail } from "app/(app)/(common)/(common)/users/usersUtils";
import { RentalOrBuy } from "./RentalOrBuy";
import { logError } from "@lib/logger";
import { sessionStore } from "@lib/sessionStore";

export function PopupRequireEmailConfirm() {
  const { session, sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.requireMailConfirmPopup);
  const { userInfo } = useUserInfo(sessionStatus === "authenticated");
  const [isConfirmMailSent, setIsConfirmMailSent] = useState<boolean>(false);
  const [isSendingConfirmMail, setIsSendingConfirmMail] = useState<boolean>(false);
  const { pushToast } = useToast();

  const handleClick = () => {
    if (userInfo.mailAddress) {
      setIsSendingConfirmMail(true);
      updateEmail(userInfo.mailAddress, session?.user)
        .then((res) => {
          if (res.status === 200) {
            setIsConfirmMailSent(true);
          } else {
            pushToast("確認メールの送信に失敗しました。時間をおいて再度お試しください", {
              type: "error",
            });
          }
          setIsSendingConfirmMail(false);
        })
        .catch((e) => {
          pushToast("サーバに問題が発生しています。時間をおいて再度お試しください", {
            type: "error",
          });
          logError("server error: update email");
          setIsSendingConfirmMail(false);
        });
    }
  };

  if (sessionStatus === "authenticated" && userInfo && !userInfo?.isMailAddressVerified) {
    return (
      <Dialog
        storeKey={STORE_KEYS.requireMailConfirmPopup}
        className="mode-req-mailconfirm"
        preventClose={true}
      >
        <p className="dialog-h">
          <RentalOrBuy />
          するには
          <br />
          メールアドレスの認証が必要です
        </p>
        <div className="dialog-main">
          <input
            type="text"
            className="form-input-text mode-margin-bottom"
            readOnly
            value={userInfo.mailAddress}
          />
          {isConfirmMailSent && (
            <p className="form-result mode-ok">
              確認メールを送信しました。メールボックスをご確認ください。確認が済みましたこの画面を
              <a
                className="form-result-link"
                onClick={() => {
                  window.location.reload();
                }}
              >
                リロード
              </a>
              ください
            </p>
          )}
          {!isConfirmMailSent && (
            <button
              className="form-btn mode-submit"
              type="button"
              onClick={handleClick}
              disabled={isSendingConfirmMail}
            >
              認証する
            </button>
          )}
        </div>
      </Dialog>
    );
  }
}
